import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useCallback } from 'react';
import { appleId } from '../../util/apiUtil';
import ApplePayButton from './CartHelpers/ApplePayButton'; // export const ApplePayMP =  React.memo(props => {

export var ApplePayMP = function ApplePayMP(props) {
  var check = props.check,
      tipAmount = props.tipAmount,
      total = props.total,
      setPayOrderPayload = props.setPayOrderPayload,
      payForOrder = props.payForOrder,
      canUseApplePay = props.canUseApplePay,
      setCanUseApplePay = props.setCanUseApplePay,
      hideApplePaymentOption = props.hideApplePaymentOption,
      selectedPaymentType = props.selectedPaymentType;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isApplePayAvailable = _useState2[0],
      setApplePayAvailable = _useState2[1];

  useEffect(function () {
    if (window.ApplePaySession && props.applePayEnabled) {
      if (window.ApplePaySession.canMakePayments()) {
        setApplePayAvailable(true);
        setCanUseApplePay(true);
      } else {
        setCanUseApplePay(false);
      }
    } else {
      setCanUseApplePay(false);
    }
  }, [props.applePayEnabled, canUseApplePay]);

  if (isApplePayAvailable && check && canUseApplePay && !hideApplePaymentOption && selectedPaymentType) {
    return /*#__PURE__*/React.createElement(ApplePayButton, _extends({}, props, {
      //   cost={{Total: check.TotalToPay}}
      cost: {
        Total: total
      },
      tipAmount: tipAmount,
      payForOrder: payForOrder,
      setPayOrderPayload: setPayOrderPayload,
      check: check,
      merchantIdentifier: appleId.merchantId
    }));
  }

  return null;
};